module.exports = __webpack_public_path__ + "static/share-109a0bc9900ee721e38dc7d6f090ec48.png";